import { render, staticRenderFns } from "./ManagementPanel.vue?vue&type=template&id=d8b5f256&"
import script from "./ManagementPanel.vue?vue&type=script&lang=js&"
export * from "./ManagementPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports